import { NotificationPayloadT } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';


import { notificationActions } from '../../../../components/notifications/actions/notification';
import {
  TeamsCreateModalDispatchProps,
  TeamsCreateModalOwnProps,
  TeamsCreateModalStateProps,
  TeamsCreateModalView,
} from '../components/teamsCreateModal';

const mapDispatchToProps = (
  dispatch: Dispatch,
): TeamsCreateModalDispatchProps => ({
  notificationAdd: (payload: NotificationPayloadT) =>
    dispatch(notificationActions.notificationAdd(payload)),
});

const TeamCreateModalViewConnected = connect<
  TeamsCreateModalStateProps,
  TeamsCreateModalDispatchProps,
  TeamsCreateModalOwnProps,
  {}
>(
  undefined,
  mapDispatchToProps,
)(TeamsCreateModalView);

export { TeamCreateModalViewConnected as TeamsCreateModal };
